import api from "../../../../utils/api";
const apiUrl = process.env.REACT_APP_BASE_URL2;

export const getAllPlans = async (page = 0, limit = 10, search = "") => {
    try {
        const res = await api.get(
          `/getUsers?requestFor=PlanDetails&page=${page + 1}&size=${limit}&sortBy=requested_at&orderBy=desc`,
          { baseURL:  apiUrl}
    
        );
        return res;
      } catch (err) {
        return err;
      }
};